import React, { useState } from "react";
import * as Icon from 'react-feather';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.scss";
import Sobre from "./pages/Sobre";
import BlogDetails from "./pages/BlogDetails";
import Blog from "./pages/Blog";
import Contato from "./pages/Contato";
import Home from "./pages/Home";
import Notfound from "./pages/Notfound";
import Portfolios from "./pages/Portfolios";
import Curriculo from "./pages/Curriculo";
import PoliticaDePrivacidade from "./pages/PoliticaDePrivacidade";

function App() {
  const [lightMode, setLightMode] = useState(false); // Made it true if you want to load your site light mode primary

  lightMode ? document.body.classList.add('light') : document.body.classList.remove('light');

  const handleMode = () => {
    if (!lightMode) {
      setLightMode(true);
      document.body.classList.add('light')
    } else {
      setLightMode(false);
      document.body.classList.remove('light')
    }
  }

  return (
    <BrowserRouter>

    {/*
      <div className="light-mode">
        <span className="icon">
          <Icon.Sun />
        </span>
        <button className={lightMode ? 'light-mode-switch active' : 'light-mode-switch'} onClick={() => handleMode()}></button>
      </div>    
    */}

      <Switch>
        <Route path="/" exact>
          <Home lightMode={lightMode}/>
        </Route>
        <Route path="/sobre" component={Sobre} />
        <Route path="/curriculo" component={Curriculo} />
        <Route path="/portfolios" component={Portfolios} />
        <Route path="/blog" exact component={Blog} />
        <Route path="/blogs/blog-details/:id/:title" component={BlogDetails} />
        <Route path="/contato" component={Contato} />
        <Route path="/politica-de-privacidade" component={PoliticaDePrivacidade} />
        <Route path="*" component={Notfound} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
